import { ChangeEvent, useEffect, useState } from 'react';
import {
    addDocToCompareBundles,
    COMPARE_BUNDLES_EVENT,
    getCompareBundlesFromStorage,
    getCompareBundlesUrl,
    isCompareBundlesDocumentIdChecked,
    MAX_ITEMS,
    removeDocFromCompareBundles
} from '../../compare-bundles/domain/compare-bundles-provider';
import { CompareTypeEnum } from '../../list-page/compare/compare-type-enum';
import {
    addDocToCompareServers,
    COMPARE_SERVERS_EVENT, getCompareServersFromStorage, getCompareServersUrl,
    isCompareServersDocumentIdChecked, removeDocFromCompareServers
} from '../../compare-servers/domain/compare-servers-provider';

interface ICompareProducts {
    documentID: number;
    callback?: Function;
    compareType?: CompareTypeEnum;
}

const CompareProducts = (props: ICompareProducts) => {

    const { documentID, compareType } = props;
    const [ checked, setChecked] = useState(false);

    useEffect(() => {
        const init = () => {
            if(compareType === CompareTypeEnum.SoundGridServers) {
                setChecked(isCompareServersDocumentIdChecked(documentID));
            }
            else{
                setChecked(isCompareBundlesDocumentIdChecked(documentID));
            }
        };

        init();

        const compareEvent = compareType === CompareTypeEnum.SoundGridServers ? COMPARE_SERVERS_EVENT : COMPARE_BUNDLES_EVENT;

        document.addEventListener(compareEvent, init);

        return () => {
            document.removeEventListener(compareEvent, init);
        };

    }, [
        documentID,
        compareType,
    ]);

    const onChangeHandler = (evt: ChangeEvent<HTMLInputElement>) => {
        const $target = evt.target;

        const data = compareType === CompareTypeEnum.SoundGridServers ? getCompareServersFromStorage() : getCompareBundlesFromStorage();

        if(
            $target.checked &&
            data.length >= MAX_ITEMS &&
            (typeof props.callback === 'function')) {
                // Show popup --------------
                props.callback ();
            return;
        }

        setChecked($target.checked);

        if($target.checked) {
            if(compareType === CompareTypeEnum.SoundGridServers) {
                addDocToCompareServers(documentID);
            }
            else{
                addDocToCompareBundles(documentID);
            }
        }
        else{
            if(compareType === CompareTypeEnum.SoundGridServers) {
                removeDocFromCompareServers(documentID);
            }
            else{
                removeDocFromCompareBundles(documentID);
            }
        }
    };

    const performRedirect = () => {
        window.location.href = compareType === CompareTypeEnum.SoundGridServers ? getCompareServersUrl() : getCompareBundlesUrl();
    };

    return (
        <>
            {
                !checked &&
                <label className="hidden md:flex items-center mt-2">
                    <input
                        type="checkbox"
                        className="mr-2"
                        onChange={ onChangeHandler }
                        checked={ checked }
                    />
                    <span>Compare</span>
                </label>
            }

            {
                checked &&
                <div className="hidden md:flex items-center mt-2">
                    <input
                        type="checkbox"
                        className="mr-2"
                        onChange={ onChangeHandler }
                        checked={ checked }
                    />
                    <button
                        type="button"
                        onClick={ performRedirect }
                        className="underline text-blue-200">Compare Now</button>
                </div>
            }
        </>
    )
};

export default CompareProducts;